import React from 'react'
import Style from './style'

// Container for multiple prizes
export const PrizeContainer = ({children, ...props}) => (
	<Style.PrizeContainer {...props}>{children}</Style.PrizeContainer>
)

// Individual prize item wrapper
export const PrizeItem = ({children, simplified = false, ...props}) => (
	<Style.PrizeItem $simplified={simplified} {...props}>
		{children}
	</Style.PrizeItem>
)

// Prize header with title and optional actions
export const PrizeHeader = ({
	title,
	index,
	onRemove,
	showRemoveButton = true,
	simplified = false,
	children,
	...props
}) => (
	<Style.PrizeHeader $simplified={simplified} {...props}>
		<Style.PrizeTitle $simplified={simplified}>
			{title || `프라이즈 ${index + 1}`}
		</Style.PrizeTitle>
		{children}
		{showRemoveButton && onRemove && !simplified && (
			<Style.RemoveButton onClick={onRemove} type='button'>
				삭제
			</Style.RemoveButton>
		)}
	</Style.PrizeHeader>
)

// Wrapper for prize editor content
export const PrizeEditorWrapper = ({
	children,
	simplified = false,
	...props
}) => (
	<Style.PrizeEditorWrapper $simplified={simplified} {...props}>
		{children}
	</Style.PrizeEditorWrapper>
)

// Complete prize component that combines all parts
export const Prize = ({
	index,
	title,
	onRemove,
	showRemoveButton = true,
	simplified = false,
	children,
	headerContent,
	...props
}) => (
	<PrizeItem simplified={simplified} {...props}>
		<PrizeHeader
			title={title}
			index={index}
			onRemove={onRemove}
			showRemoveButton={showRemoveButton}
			simplified={simplified}
		>
			{headerContent}
		</PrizeHeader>
		<PrizeEditorWrapper simplified={simplified}>{children}</PrizeEditorWrapper>
	</PrizeItem>
)

// Export the style object for direct access if needed
export {Style as PrizeStyles}

const PrizeComponents = {
	Container: PrizeContainer,
	Item: PrizeItem,
	Header: PrizeHeader,
	EditorWrapper: PrizeEditorWrapper,
	Prize,
	Styles: Style,
}

export default PrizeComponents
